import axios from 'axios';
import { session, SessionChanged, SessionExpired } from './session';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });
const expired = (error) => {
  if (error instanceof SessionExpired) window.location.assign('/app/login');
  return Promise.reject(error);
};
api.interceptors.request.use(async (config) => {
  try {
    const id = config.sessionId ?? session.read()?.id;
    const token = await session.accessToken({ expectedId: id });
    if (session.read()?.id !== id) throw new SessionChanged();
    config.sessionId = id;
    config.headers.Authorization = `Bearer ${token}`;
    config.sentAccessToken = token;
    return config;
  } catch (error) { return expired(error); }
});
api.interceptors.response.use((response) => {
  if (response.config.sessionId !== session.read()?.id) throw new SessionChanged();
  return response;
}, async (error) => {
  const request = error.config;
  if (request?.sessionId && request.sessionId !== session.read()?.id) throw new SessionChanged();
  if (error.response?.status === 401 && request?.sessionId && !request.authRetried) {
    try {
      await session.accessToken({ force: true, expectedId: request.sessionId,
        rejectedToken: request.sentAccessToken });
      if (session.read()?.id !== request.sessionId) throw new SessionChanged();
      // Refresh for future operations; do not replay an ambiguous write.
      if (['get', 'head'].includes(request.method?.toLowerCase())) {
        request.authRetried = true;
        return api(request);
      }
    } catch (failure) { return expired(failure); }
  }
  return Promise.reject(error);
});
export default api;
